var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('circle',{attrs:{"cx":"13","cy":"13","r":"12","stroke":_vm.stroke,"fill":"#fff","stroke-width":"1.3"}})}
var staticRenderFns = []

export { render, staticRenderFns }